import React from 'react'
import { getImageUrl } from '../../utils/image'
import s from './GeoentityBlockPublicTransport.less'
import classnames from 'classnames'
import SVGIcon from '../../svg/SVGIcon'
import StepUpNumber from '../../genericComponents/StepUpNumber'

function Time({ item, first, realTime }) {
  return (
    <span className={classnames(s.time)}>
      {first && (
        <StepUpNumber
          label={item}
          mainClassName={s.bigNumber}
          restClassName={classnames(s.bigMinutes, realTime && s.bigMinutesRealtime)}
        />
      )}
      {!first && <span>, {item}</span>}
      {realTime && (
        <span className={classnames(s.waves, first && s.wavesFirst)}>
          <SVGIcon icon="real-time" />
        </span>
      )}
    </span>
  )
}

function Departure({ label, realTime, times = [] }) {
  return (
    <div className={s.departure}>
      <span className={s.direction}>{label}</span>
      <span className={s.times}>
        {times.map((item, idx) => (
          <Time key={idx} first={idx === 0} item={item} realTime={realTime} />
        ))}
      </span>
    </div>
  )
}

export default function GeoentityBlockPublicTransport(props) {
  const { data = {} } = props
  const { mode, line, schedule, departures = [] } = data
  if (!mode || !line) return null

  return (
    <div className={s.container}>
      <p className={s.title}>
        <img className={s.logo} src={getImageUrl(mode.url)} alt={mode.alt} />
        <img className={s.logo} src={getImageUrl(line.url)} alt={line.alt} />
      </p>
      <hr className={s.hr} />
      {schedule && <p className={s.schedule}>{schedule}</p>}
      {departures.map((departure, idx) => (
        <Departure key={idx} {...departure} />
      ))}
    </div>
  )
}
